import { Navigate, Route, Routes } from 'react-router-dom';
import { FormProvider } from './context/FormContext';
import ApplicationPage from './pages/ApplicationPage';
import SchedulingPage from './pages/SchedulingPage';
import ConfirmationPage from './pages/ConfirmationPage';

export default function App() {
  return (
    <FormProvider>
      <Routes>
        <Route path="/" element={<ApplicationPage />} />
        <Route path="/agenda" element={<SchedulingPage />} />
        <Route path="/confirmacion" element={<ConfirmationPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </FormProvider>
  );
}
